import { Client } from '../../models/client';
import { ApiResponse, httpService } from '../httpService';

export interface GetClientParams {
  skip?: number;
  take?: number;
  filter?: string;
  includeDeleted?: boolean;
  salesPersonId?: string;
}

export const clientsApiUrl = '/api/Clients';

export const getClients = async (
  params: GetClientParams = {}
): Promise<ApiResponse<Client>> => {
  const response = await httpService.get<ApiResponse<Client>>(
    `${clientsApiUrl}/`,
    {
      params,
    }
  );

  return response.data;
};

export const getClient = async (idClient: string): Promise<Client> => {
  const response = await httpService.get<Client>(
    `${clientsApiUrl}/${idClient}`
  );

  return response.data;
};

export const addNewClient = async (
  newClient: Partial<Client>
): Promise<void> => {
  await httpService.post(clientsApiUrl, newClient);
};

export const editClient = async (
  idClient: string,
  editClientInfo: Partial<Client>
): Promise<void> => {
  await httpService.put(`${clientsApiUrl}/${idClient}`, editClientInfo);
};

export const deleteClient = async (idClient: string): Promise<void> => {
  await httpService.delete(`${clientsApiUrl}/${idClient}`);
};
